<!-- 类似 cba 的赛程展示结果 -->
<template>
  <div
    class="matchItemRow"
    :class="themeClass === 'onlyDisplay' ? 'onlyDisplay' : ''"
  >
    <span class="item_matchLeft">
      <template
        v-if="viewMode === 'scheduleNoticeCBA' && chooseState === 'choose'"
      >
        <span class="matchLeft_colum1">
          <span
            class="matchLeft_colum1_row1"
            v-text="_valPerFormatHandler(`${item.weekCN} ${item.gameTime}`)"
          ></span>
          <span class="matchLeft_colum1_row2">
            <span
              class="matchItem_checkbox"
              v-for="channelItem in item.channelTvList"
              :class="channelItem.act ? 'act' : ''"
              :key="channelItem.value"
              @click.stop="matchItem_checkbox(item, channelItem)"
            >
              <span class="matchItem_channelItem" :class="channelType">
                <svg
                  t="1693726421166"
                  class="icon"
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="21127"
                  width="80%"
                  height="80%"
                >
                  <path
                    d="M892.064 261.888a31.936 31.936 0 0 0-45.216 1.472L421.664 717.248l-220.448-185.216a32 32 0 1 0-41.152 48.992l243.648 204.704a31.872 31.872 0 0 0 20.576 7.488 31.808 31.808 0 0 0 23.36-10.112L893.536 307.136a32 32 0 0 0-1.472-45.248z"
                    p-id="21128"
                  ></path>
                </svg>
              </span>
              <span
                class="matchItem_channelItem_text"
                v-text="channelItem.name"
              ></span>
            </span>
          </span>
        </span>
      </template>
      <template
        v-else-if="
          viewMode === 'scheduleNoticeCBA' && themeClass === 'onlyDisplay'
        "
      >
        <span class="matchLeft_colum1">
          <span
            class="matchLeft_colum1_row1"
            v-text="_valPerFormatHandler(`${item.matchWeek} ${item.matchTime}`)"
          ></span>
          <span class="matchLeft_colum1_row2">
            <span
              class="matchItem_checkbox"
              v-for="channelItem in item.channels"
              :key="channelItem.channelId"
            >
              <span
                class="matchItem_channelItem_text channelName"
                v-text="channelItem.channelName"
              ></span>
            </span>
          </span>
        </span>
      </template>
      <template v-else>
        <span class="matchLeft_colum1">
          <span
            class="matchLeft_colum1_row1"
            v-text="_valPerFormatHandler(item.matchName)"
          ></span>
          <span
            v-if="themeClass === 'onlyDisplay'"
            class="matchLeft_colum1_row2"
            v-text="
              _valPerFormatHandler(
                `${item.gameDate ? item.gameDate : ''} ${item.gameTime}`
              )
            "
          ></span>
          <span
            v-else
            class="matchLeft_colum1_row2"
            v-text="_valPerFormatHandler(item.gameTime)"
          ></span>
        </span>
      </template>
    </span>
    <span class="item_matchCenter combat">
      <span class="matchCenter_colum1">
        <span class="matchCenter_colum1_row">
          <span class="delegationLogo" :class="item.homeLogo ? 'isLogo' : ''">
            <img v-if="item.homeLogo" :src="item.homeLogo" />
          </span>
          <span
            class="delegationName"
            v-text="_valPerFormatHandler(item.homeName)"
          ></span>
        </span>
        <span class="matchCenter_colum1_row">
          <span class="delegationLogo" :class="item.awayLogo ? 'isLogo' : ''">
            <img v-if="item.awayLogo" :src="item.awayLogo" />
          </span>
          <span
            class="delegationName"
            v-text="_valPerFormatHandler(item.awayName)"
          ></span>
        </span>
      </span>
      <span class="matchCenter_colum2" :class="matchStatusClassName(item)">
        <span class="matchCenter_colum2_row" v-text="item.homeScore"></span>
        <span class="matchCenter_colum2_row" v-text="item.awayScore"></span>
      </span>
    </span>
    <span class="item_matchRight">
      <template v-if="themeClass === 'onlyDisplay'">
        <span
          class="matchRight_status"
          :class="matchStatusClassName(item)"
          v-text="_valPerFormatHandler(item.matchStatusName)"
        ></span>
      </template>
      <template v-else>
        <span
          class="matchRight_status"
          :class="matchStatusClassName(item)"
          v-text="matchStatusToMatchCN(item.matchStatus, item)"
        ></span>
      </template>
    </span>
    <!-- <span class="item_absChoose" v-show="chooseState === 'choose'">
      <span class="checkbox_item">
        <svg
          t="1693726421166"
          class="icon"
          viewBox="0 0 1024 1024"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          p-id="21127"
          width="80%"
          height="80%"
        >
          <path
            d="M892.064 261.888a31.936 31.936 0 0 0-45.216 1.472L421.664 717.248l-220.448-185.216a32 32 0 1 0-41.152 48.992l243.648 204.704a31.872 31.872 0 0 0 20.576 7.488 31.808 31.808 0 0 0 23.36-10.112L893.536 307.136a32 32 0 0 0-1.472-45.248z"
            p-id="21128"
          ></path>
        </svg>
      </span>
    </span> -->
  </div>
</template>

<script>
import cup_base_data_mixin from '@mixins/cup_base_data'
export default {
  name: 'league_CBA_matchItem',
  mixins: [cup_base_data_mixin],
  props: {
    item: {
      type: Object,
      default: () => {
        return {}
      },
    },
    detailPathName: {
      type: [String, Array],
      default: '',
    },
    chooseState: {
      type: String,
      default: 'default', //['default', 'choose', 'none'] none：没有鼠标经过效果
    },
    localStorageName: {
      type: String,
      default: '',
    },
    localStorageSaveDate: {
      type: String,
      default: '',
    },
    themeClass: {
      // 不同页面视图的展示
      type: String,
      default: '',
    },
    viewMode: {
      // 相同页面，控制不同视图的展示;这个就是matchListViewMode中的元素
      type: String,
      default: '',
    },
    channelType: {
      type: String,
      default: 'radio', //频道选择的模式，radio:单选；checkbox:多选
    },
    matchStatusOpts: {
      type: [Object, null],
      default: null,
    },
  },
  data() {
    return {
      // apiVal2WebValMap: {
      //   1: 0,
      //   2: 1,
      //   3: 3,
      //   4: 2,
      //   5: 0,
      //   6: 3,
      // },
      // webValStyleArr: [
      //   {
      //     colorClass: 'unstart',
      //     key: [1, 5], //['未开始', '延期']
      //     name: ['赛前分析', '赛前分析'],
      //   },
      //   {
      //     colorClass: 'playing',
      //     key: [2], // 进行中
      //     name: ['节次+时间'],
      //   },
      //   {
      //     colorClass: 'finished',
      //     key: [4], // 已完赛
      //     name: ['数据统计'],
      //   },
      //   {
      //     colorClass: 'other', // 置灰，不可点
      //     key: [3, 6],
      //     name: ['已取消', '待定'],
      //   },
      // ],
      // apiVal2WebValMap: {
      //   'Pre-Game': 0,
      //   'in-Progress': 1,
      //   Final: 2,
      //   Cancelled: 3,
      //   Postponed: 0,
      //   TBD: 3,
      // },
      // webValStyleArr: [
      //   {
      //     colorClass: 'unstart',
      //     key: ['Pre-Game', 'Postponed'], //['未开始', '延期']
      //     name: ['赛前分析', '赛前分析'],
      //   },
      //   {
      //     colorClass: 'playing',
      //     key: ['in-Progress'], // 进行中
      //     name: ['节次+时间'],
      //   },
      //   {
      //     colorClass: 'finished',
      //     key: ['Final'], // 已完赛
      //     name: ['数据统计'],
      //   },
      //   {
      //     colorClass: 'other', // 置灰，不可点
      //     key: ['Cancelled', 'TBD'],
      //     name: ['已取消', '待定'],
      //   },
      // ],
    }
  },
  methods: {
    matchStatusToMatchCN(matchStatus, dataItem) {
      if (!this.matchStatusOpts) return
      const { apiVal2WebValMap, webValStyleArr } = this.matchStatusOpts
      let index = apiVal2WebValMap[matchStatus]
      let item = webValStyleArr[index]
      let matchCN = item.name[item.key.indexOf(matchStatus)]
      console.debug(
        'matchStatusToMatchCN:',
        matchStatus,
        index,
        item,
        item.key.indexOf(matchStatus),
        matchCN
      )
      if (item.colorClass === 'playing') {
        matchCN = `${this._valPerFormatHandler(
          dataItem.currentPeriodName
        )} ${this._valTimeFormatHandler(
          dataItem.timeMinutes
        )}:${this._valTimeFormatHandler(dataItem.timeSeconds)}`
      }
      return this._valPerFormatHandler(matchCN)
    },
    matchStatusClassName(item) {
      if (this.matchStatusOpts) {
        return ''
      } else {
        return this.matchStatusOpts.webValStyleArr[
          this.matchStatusOpts.apiVal2WebValMap[item.matchStatus]
        ].colorClass
      }
    },
    // goDetail(item) {
    //   console.debug(item, this.openNewWeb, this.$dynamicConfig)
    //   if (this.chooseState === 'choose' && this.localStorageName) {
    //     let chooseObj = this.$localStorage.getItem(this.localStorageName)
    //       ? JSON.parse(this.$localStorage.getItem(this.localStorageName))
    //       : {
    //           cid: this.currCid,
    //           // date: this.localStorageSaveDate,
    //           chooseItemArr: [],
    //           chooseIdArr: [],
    //         }
    //     if (chooseObj.cid === this.currCid) {
    //       if (chooseObj.chooseItemArr.length === 0) {
    //         let newItem = JSON.parse(JSON.stringify(item))
    //         newItem.isChooseFlag = true
    //         chooseObj.chooseItemArr.push(newItem)
    //         chooseObj.chooseIdArr.push(item.chooseId)
    //       } else {
    //         let chooseItemArr = []
    //         let chooseIdArr = []
    //         chooseObj.chooseItemArr.forEach((chooseItem) => {
    //           if (chooseItem.chooseId !== item.chooseId) {
    //             chooseItemArr.push(chooseItem)
    //             chooseIdArr.push(chooseItem.chooseId)
    //           }
    //         })
    //         if (chooseItemArr.length === chooseObj.chooseItemArr.length) {
    //           let newItem = JSON.parse(JSON.stringify(item))
    //           newItem.isChooseFlag = true
    //           chooseItemArr.push(newItem)
    //           chooseIdArr.push(item.chooseId)
    //         }
    //         chooseObj.chooseItemArr = chooseItemArr
    //         chooseObj.chooseIdArr = chooseIdArr
    //       }
    //       this.$localStorage.setItem(
    //         this.localStorageName,
    //         JSON.stringify(chooseObj)
    //       )
    //       this.$emit('changeChooseNumEvent', {
    //         localStorageName: this.localStorageName,
    //         type: this.viewMode,
    //         val: chooseObj.chooseIdArr.length,
    //         init: false,
    //       })
    //       console.debug('chooseObj:', chooseObj)
    //     } else {
    //       console.error('错误：赛事不同')
    //     }
    //   } else if (this.detailPathName) {
    //     let currSportsDetail = {
    //       sportsId: item.sportsId,
    //       eventId: item.eventId,
    //       matchId: item.matchId,
    //       sportsName: item.sportsName,
    //       eventName: item.eventName,
    //       // matchDetail: item
    //     }
    //     console.debug('sportsDetail_compreScore:', currSportsDetail)
    //     this.$localStorage.setItem(
    //       'mixtmt_platfromV4_currSportsDetail',
    //       JSON.stringify(currSportsDetail)
    //     )
    //     let params = {
    //       cid: this.currCid,
    //       sid: item.seasonId ? item.seasonId : this.currSid,
    //       sportsId: item.sportsId,
    //       eventId: item.eventId,
    //       mid: item.matchId,
    //     }
    //     let detailPathName = ''
    //     if (typeof this.detailPathName === 'object') {
    //       // object
    //       // this.detailPathName = [
    //       //   {
    //       //     pathName: 'CBAScheduleDetailPreMatch',
    //       //     matchStatus: '1',
    //       //   },
    //       //   {
    //       //     pathName: 'CBAScheduleDetailPreMatch',
    //       //     matchStatus: '5',
    //       //   },
    //       //   {
    //       //     pathName: 'CBAScheduleDetailAnalysis',
    //       //     matchStatus: 'all',
    //       //   },
    //       // ]
    //       this.detailPathName.forEach((pathItem) => {
    //         if (item.matchStatus + '' === pathItem.matchStatus) {
    //           detailPathName = pathItem.pathName
    //         }
    //       })
    //       if (!detailPathName) {
    //         detailPathName =
    //           this.detailPathName[this.detailPathName.length - 1].pathName
    //       }
    //     } else {
    //       // string
    //       detailPathName = this.detailPathName
    //     }
    //     console.debug('detailPathName:', detailPathName)
    //     this.openNewWeb(this.$router, detailPathName, params)
    //   }
    // },
    matchItem_checkbox(matchItem, actItem) {
      this.$emit('clickMatchItemCheckboxItemEvent', {
        matchItem,
        actItem,
        type: this.channelType ? this.channelType : '',
      })
      console.debug('matchItem_checkbox')
    },
    _valPerFormatHandler(val, ceil) {
      let data
      if (val === undefined || val === null || val === '' || val === ' ') {
        return '-'
      }
      data = `${val}${ceil ? ceil : ''}`
      return data
    },
    _valTimeFormatHandler(val) {
      let data
      if (val === undefined || val === null || val === '' || val === ' ') {
        data = '00'
      } else {
        if (val - 0 <= 9) {
          data = `0${val}`
        }
        data = val
      }
      return data
    },
  },
}
</script>

<style lang="scss" scoped>
.mixtmt_pc,
.mixtmt_ipad {
  .matchItemRow {
    position: relative;
    display: flex;
    display: -webkit-flex;
    justify-content: flex-start;
    align-items: flex-start;
    height: auto;
    width: 100%;
    padding: 0.694vw 1.388vw;
    color: var(--mixtmt_greyColor3);
    /* border-bottom: 1px solid var(--mixtmt_greyColor5); */
    transition: padding 0.3s linear;
    &.onlyDisplay {
      .item_matchLeft {
        display: flex;
        display: -webkit-flex;
        justify-content: flex-start;
        align-items: center;
        width: 10.42vw;
        .matchLeft_colum1 {
          width: 100%;
        }
      }
      .item_matchCenter {
        width: calc(100% - 10.42vw - 6.94vw);
        .matchCenter_colum1 {
          width: 10.42vw;
        }
        .matchCenter_colum2 {
          width: calc(100% - 10.42vw);
        }
      }
    }
    /* &.choose {
      padding: 0.694vw 1.388vw 0.694vw 2.776vw;
      .item_absChoose {
        width: 2.776vw;
        display: flex;
        display: -webkit-flex;
        justify-content: center;
        align-items: center;
        .checkbox_item {
          width: 1.388vw;
          height: 1.388vw;
          border-radius: 0.208vw;
          border: 1px solid var(--mixtmt_subColor1_1);
          display: flex;
          display: -webkit-flex;
          justify-content: center;
          align-items: center;
          background-color: var(--mixtmt_whiteColor);
          svg {
            opacity: 0;
            fill: var(--mixtmt_whiteColor);
            transition: all 0.3s linear;
          }
        }
      }
      &.chooseAct {
        .checkbox_item {
          background-color: var(--mixtmt_subColor1_1);
          svg {
            opacity: 1;
          }
        }
      }
    } */
    .matchLeft_colum1,
    .matchCenter_colum1,
    .matchCenter_colum2 {
      display: flex;
      display: -webkit-flex;
      justify-content: space-between;
      align-items: flex-start;
      flex-direction: column;
      height: auto;
    }
    .matchLeft_colum1_row1,
    .matchCenter_colum1_row,
    .matchCenter_colum2_row {
      margin-bottom: 0.347vw;
    }
    .item_matchLeft {
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: center;
      width: 20.83vw;
      .matchLeft_colum1 {
        width: 100%;
        .matchLeft_colum1_row1 {
          width: 100%;
          font-size: 1.11vw;
          line-height: 2.083vw;
          height: 2.083vw;
          font-weight: bold;
        }
        .matchLeft_colum1_row2 {
          display: flex;
          display: -webkit-flex;
          justify-content: flex-start;
          align-items: center;
          width: 100%;
          height: 2.083vw;
          font-size: 1.11vw;
          color: var(--mixtmt_greyColor2);
        }
      }
    }
    .item_matchCenter {
      display: flex;
      display: -webkit-flex;
      justify-content: space-between;
      align-items: center;
      width: calc(100% - 34.71vw);
      .matchCenter_colum1 {
        width: 20.83vw;
        .matchCenter_colum1_row {
          width: 100%;
          height: 2.083vw;
          display: flex;
          display: -webkit-flex;
          justify-content: flex-start;
          align-items: center;
          .delegationLogo {
            width: 1.68vw;
            height: 1.68vw;
            border-radius: 50%;
            overflow: hidden;
            background-color: var(--mixtmt_greyColor0);
            &.isLogo {
              background-color: transparent;
            }
            img {
              width: 100%;
              height: 100%;
              object-fit: contain;
              display: block;
            }
          }
          .delegationName {
            width: calc(100% - 1.68vw);
            padding-left: 0.972vw;
            font-size: 0.972vw;
            font-weight: bold;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
      }
      .matchCenter_colum2 {
        width: calc(100% - 20.83vw);
        padding-left: 0.694vw;
        &.playing {
          color: var(--mixtmt_subColor3_1);
        }
        .matchCenter_colum2_row {
          width: 100%;
          height: 2.083vw;
          font-size: 0.972vw;
          line-height: 2.083vw;
          font-weight: bold;
          text-align: left;
          padding-right: 0.347vw;
        }
      }
    }
    .item_matchRight {
      position: absolute;
      right: 1.388vw;
      top: 50%;
      z-index: 10;
      transform: translateY(-50%);
      width: 6.94vw;
      display: flex;
      display: -webkit-flex;
      justify-content: flex-end;
      align-items: center;
      .matchRight_status {
        width: 6.94vw;
        height: 2.083vw;
        line-height: 2.083vw;
        font-size: 0.972vw;
        text-align: center;
        border-radius: 0.278vw;
        &.unstart {
          color: var(--mixtmt_greyColor2);
          border: 1px solid var(--mixtmt_greyColor2);
        }
        &.playing {
          color: var(--mixtmt_subColor3_1);
          border: 1px solid var(--mixtmt_subColor3_1);
        }
        &.finished {
          color: var(--mixtmt_greyColor2);
          border: 1px solid var(--mixtmt_greyColor2);
        }
        &.other {
          background-color: var(--mixtmt_greyColor0);
          color: var(--mixtmt_greyColor2);
          border: 1px solid var(--mixtmt_greyColor0);
        }
      }
    }
    .matchItem_checkbox {
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: center;
      width: auto;
      margin-right: 0.974vw;
      .matchItem_channelItem {
        width: 1.11vw;
        height: 1.11vw;
        border-radius: 0.208vw;
        display: flex;
        display: -webkit-flex;
        justify-content: center;
        align-items: center;
        background-color: var(--mixtmt_whiteColor);
        &.radio {
          border-radius: 50%;
          border: 1px solid var(--mixtmt_greyColor2);
        }
        &.checkbox {
          border: 1px solid var(--mixtmt_greyColor2);
        }
        svg {
          opacity: 0;
          fill: var(--mixtmt_whiteColor);
          transition: all 0.3s linear;
        }
      }
      .matchItem_channelItem_text {
        padding: 0 0.374vw;
        font-size: 0.974vw;
        color: var(--mixtmt_greyColor2);
        &.channelName {
          padding: 0 0.374vw 0 0;
        }
      }
      &.act {
        .matchItem_channelItem {
          background-color: var(--mixtmt_mainColor6);
          border: 1px solid var(--mixtmt_mainColor6);
          svg {
            opacity: 1;
          }
        }
        .matchItem_channelItem_text {
          color: var(--mixtmt_mainColor6);
          font-weight: bold;
        }
      }
    }
    /* .item_absChoose {
      position: absolute;
      left: 0;
      top: 0;
      z-index: 2;
      width: 0;
      height: 100%;
      transition: width 0.3s linear;
    } */

    &.itemGreyColor {
      /* 赛程文字置灰，不可点击进入赛果 */
      /* color: var(--mixtmt_greyColor4); */
      opacity: 0.5;
    }
  }
}

.mixtmt_pc {
  .match_list_item:not(.none) {
    &:hover,
    &.choose.chooseAct {
      .matchItemRow {
        background-color: var(--mixtmt_scheduleItem_actBgColor);
        color: var(--mixtmt_whiteColor);
        .item_matchLeft {
          .matchLeft_colum1 {
            .matchLeft_colum1_row2 {
              color: var(--mixtmt_whiteColor);
            }
          }
        }
        .item_matchRight {
          .matchRight_status.unstart {
            /* color: var(--mixtmt_whiteColor);
                background-color: var(--mixtmt_subColor3_1);
                border: 1px solid var(--mixtmt_subColor3_1); */
            color: var(--mixtmt_scheduleItem_actBgColor);
            background-color: var(--mixtmt_whiteColor);
            border: 1px solid var(--mixtmt_whiteColor);
          }
          .matchRight_status.playing {
            color: var(--mixtmt_whiteColor);
            background-color: var(--mixtmt_subColor3_1);
            border: 1px solid var(--mixtmt_subColor3_1);
          }
          .matchRight_status.finished {
            /* opacity: 0.45; */
            /* color: var(--mixtmt_mainColor); */
            color: var(--mixtmt_scheduleItem_actBgColor);
            background-color: var(--mixtmt_whiteColor);
            border: 1px solid var(--mixtmt_whiteColor);
          }
          .matchRight_status.other {
            background-color: var(--mixtmt_greyColor0);
            color: var(--mixtmt_greyColor2);
            border: 1px solid var(--mixtmt_greyColor0);
          }
        }
        .matchItem_checkbox {
          cursor: pointer;
          .matchItem_channelItem {
            border: 1px solid var(--mixtmt_mainColor6);
            background-color: var(--mixtmt_whiteColor);
            svg {
              fill: var(--mixtmt_whiteColor);
            }
          }
          .matchItem_channelItem_text {
            color: var(--mixtmt_whiteColor);
          }
          &.act {
            .matchItem_channelItem {
              background-color: var(--mixtmt_mainColor6);
              border: 1px solid var(--mixtmt_mainColor6);
              svg {
                opacity: 1;
              }
            }
            .matchItem_channelItem_text {
              color: var(--mixtmt_whiteColor);
            }
          }
        }
      }
    }
    &.choose.chooseAct,
    &.choose,
    &.default {
      cursor: pointer;
    }
  }
}
</style>
